import React, { useState, useEffect } from "react";

import Breadcrumb from "../../../components/layout/Breadcrumb";
import CandidateReportPage from "./CandidateReportPage";
import EmployeeReportPage from "./EmployeeReportPage";
import { useDispatch, useSelector } from "react-redux";
import { setActiveMenu } from "../../../redux/slice/activeMenuSlice";

const ReportPage = () => {
  const dispatch = useDispatch();
  const [selectedFilter, setSelectedFilter] = useState("All Employee");
  const [navMenu, setNavMenu] = useState(["Employee", "Candidate"]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const activeMenu = useSelector((state) => {
    const storedMenu = state.activeMenu.menu;
    if (storedMenu) return storedMenu;
    return "employee";
  });
  useEffect(() => {
    dispatch(setActiveMenu({ menu: "employee", subMenu: "summary" }));
  }, []);

  const handleItemClick = (item) => {
    switch (item.heading) {
      case "USER_INVITE_LINK":
        navigate("/admin/settings/user-invite-link", {
          state: {
            configType: item.heading,
            configName: objectData?.USER_INVITE_LINK,
          },
        });
        break;
      case "PREONBOARDING_MAIL":
        navigate("/admin/settings/preonboarding-mail-cc", {
          state: {
            configType: item.heading,
            configName: objectData?.PREONBOARDING_MAIL,
          },
        });
        break;
      case "APPROVAL_MAIL":
        navigate("/admin/settings/approval-mail", {
          state: {
            configType: item.heading,
            configName: objectData?.APPROVAL_MAIL,
          },
        });
        break;
      case "EMPLOYEE_ID_MATRIX":
        navigate("/admin/settings/employee-id-matrix", {
          state: {
            configType: item.heading,
            configName: objectData?.EMPLOYEE_ID_MATRIX,
          },
        });
        break;
      case "EMPLOYEE_WELCOME_MAIL":
        navigate("/admin/settings/employee-welcome-mail", {
          state: {
            configType: item.heading,
            configName: objectData?.EMPLOYEE_WELCOME_MAIL,
          },
        });
        break;
      default:
        break;
    }
  };
  const [isOpen, setIsOpen] = useState(true);
  const handleToggle = () => {
    console.log("btn clicked");
    setIsOpen(!isOpen);
  };
  const panelName = "Employee";

  const handleNavClick = (menu) => {
    dispatch(
      setActiveMenu({
        menu: menu.toLowerCase().replaceAll(" ", ""),
        subMenu: "summary",
      }),
    );
    setIsMenuOpen(false);
  };

  const renderContent = () => {
    switch (activeMenu) {
      case "employee":
        return (
          <div className="profile-container">
            <EmployeeReportPage />
          </div>
        );
      case "candidate":
        return (
          <div className="profile-container">
            <CandidateReportPage />
          </div>
        );
      default:
        return (
          <div className="profile-container">
            <h5>Select a menu option</h5>
          </div>
        );
    }
  };
  return (
    <div className="container mw-100 " >
      <Breadcrumb />

      <div className="navbar-wrapper">
        <button
          type="button"
          className="menu-toggle-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <i
            className={`bi ${isMenuOpen ? "bi-x-lg" : "bi-list"} hamburger-icon`}
          ></i>
        </button>

        <div className={`navbar-container ${isMenuOpen ? "show" : ""}`}>
          {navMenu.map((menu) => {
            const menuKey = menu.toLowerCase().replaceAll(" ", "");
            return (
              <button
                type="button"
                key={menu}
                className={`btn-interactive nav-link ${activeMenu === menu.toLowerCase().replaceAll(" ", "") ? "active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(menu);
                }}
              >
                {menu}
              </button>
            );
          })}
        </div>
      </div>
      {renderContent()}
    </div>
  );
};

export default ReportPage;
